import { formatCurrencyInputOnChange } from '@fruitful/fruitils';
import type { MembershipSpend } from '@fruitful/member-profile/src/spend/types/Spend';
import { useAtomValue } from 'jotai/index';
import * as React from 'react';
import { useState } from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    KeyboardCompatibleBottomSheet,
    KeyboardCompatibleBottomSheetTextInput,
    StyledBodyMediumRegularInputNoOutline,
    YStack,
} from 'smoothie';

import { membershipSpendAtom } from '../../bills/state/BillsAtoms';

export interface Props {
    onClose: () => void;
    onSubmit: (membershipSpend: MembershipSpend | null, amount: string) => void;
}

interface EditSpendInputProps {
    onClose: () => void;
    onSubmit: (membershipSpend: MembershipSpend | null, amount: string) => void;
    spendAmountInput: string;
}

const EditSpendInput = ({
    onClose,
    spendAmountInput,
    onSubmit,
}: EditSpendInputProps) => {
    const [spendAmount, setSpendAmount] = useState<string | null>(
        spendAmountInput,
    );

    const membershipSpend = useAtomValue(membershipSpendAtom);

    return (
        <YStack
            marginTop={24}
            paddingHorizontal={4}
            width="100%"
            minWidth={300}
            alignItems="center"
            gap={16}
        >
            <KeyboardCompatibleBottomSheetTextInput
                editable
                component={StyledBodyMediumRegularInputNoOutline}
                keyboardType="number-pad"
                textAlign="center"
                defaultValue={spendAmount}
                onChangeText={(text: string) => {
                    const newAmount = formatCurrencyInputOnChange(
                        spendAmount ?? '$',
                        text,
                    ).replace(' ', '');
                    setSpendAmount(newAmount);
                }}
                width="100%"
                fontSize={40}
            />
            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Save"
                onPress={() => {
                    onSubmit(membershipSpend, spendAmount ?? '');
                    onClose();
                }}
            />
        </YStack>
    );
};

export const EditSpendSheet = ({ onClose, onSubmit }: Props) => {
    return (
        <KeyboardCompatibleBottomSheet
            onDismiss={onClose}
            title="Edit monthly spend amount"
            showCloseButton={true}
        >
            <EditSpendInput
                onSubmit={onSubmit}
                onClose={onClose}
                spendAmountInput="$"
            />
        </KeyboardCompatibleBottomSheet>
    );
};
